<div class="auth-content d-flex flex-column gap-3">
  <!-- Logo -->
  <div class="logo-container mx-auto">
    <svg-icon src="assets/logo.svg" />
  </div>

  @if (headerTitle()) {
    <h2 class="text-center fw-bold fs-4 mb-0">{{ headerTitle() }}</h2>
  }

  @if (headerSubtitle()) {
    <p class="text-center text-muted">{{ headerSubtitle() }}</p>
  }

  <ng-content />

  @if (showOAuth()) {
    <div class="divider-horizontal-lines">
      <span class="divider-line"></span>
      <span class="divider-text">or</span>
      <span class="divider-line"></span>
    </div>

    <div class="oauth-buttons">
      @for (button of authButtons(); track button.provider) {
        <component-button-with-loading
          cssClass="btn btn-light btn-lg w-100"
          [disabled]="isButtonDisabled()(button.provider)"
          [isLoading]="isButtonLoading()(button.provider)"
          (click)="onOAuthAction(button.provider)">
          <custom-icon [name]="button.iconName" size="20" />
          {{ buttonText() }} {{ button.name }}
        </component-button-with-loading>
      }
    </div>
  }

  <div class="d-flex flex-column footer-wrapper">
    <ng-content select="[authFooter]" />

    @if (showTerms()) {
      <p class="text-center small mb-0">
        By signing up, you agree to our
        <a [routerLink]="loginRoutes.terms()" class="link">Terms</a> &
        <a [routerLink]="loginRoutes.privacyPolicy()" class="link">Privacy Policy</a>.
      </p>
    }
  </div>
</div>
